import React from 'react';
import pnf from '../assets/images/404_pnf.svg'
const P404 = () => {
    return (
        <section id="p404">
            <div className="container">
                <div className="row">
                    <div className="col col-md-10 mx-auto">
                        <img src={pnf} alt="pnf"/>
                        <h2 className="text-dark">Coming soon! This page is under construction!!</h2>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default P404

